<tcm-main-frame [isLoading]="isLoading" titleKey="Screens.Patients.InfoWidget.UpdatePhoto.Title">
  <ng-container commands>
    <button title="Screens.Patients.InfoWidget.UpdatePhoto.Apply"
            class="btn btn-complete me-2"
            [disabled]="!base64img"
            (click)="save()">{{'Screens.Patients.InfoWidget.UpdatePhoto.Apply' | translate}}</button>
    <button class="btn btn-default"
            (click)="goBack()">{{'Common.SearchActionsAndDetailsActions.Cancel' | translate}}</button>
  </ng-container>

  <ng-container body>
    <tcm-details-layout>
      <div class="tcm-details-panel" form-area>
        <picture-loader (pictureLoaded)="onPictureLoaded($event)">
          <span upload-picture-button class="upload-photo"></span>

          <a activate-camera-button class="activate-camera"></a>

          <button take-photo-button class="btn btn-default me-3">
            {{'Screens.Patients.InfoWidget.UpdatePhoto.Capture' | translate}}
          </button>

          <img image-container class="image-container"
               src="{{ base64img || '/assets/images/no-photo.jpg' }}" />

        </picture-loader>
      </div>
    </tcm-details-layout>
  </ng-container>
</tcm-main-frame>
